import React from "react";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../Redux/common/actions";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

export default function FilePreviewModal() {
  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.commonReducer);

  const isOpen = showModal?.show && showModal?.method === "FP";
  const fileUrl = isOpen ? showModal?.data : null;

  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "FP", data: null },
    });
  };

  return (
    <Dialog
      open={!!isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          padding: "8px",
          backgroundColor: "rgba(240, 240, 251, 1)",
        },
      }}
    >
      <DialogContent
        sx={{
          width: "100%",
          backgroundColor: "rgba(240, 240, 251, 1)",
          p: 1,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", top: 0, right: 0, color: "#000" }}
        >
          <IoMdCloseCircleOutline />
        </IconButton>
        <Box
          sx={{
            width: "100%",
            height: { xs: "60vh", md: "80vh" },
            mt: 1,
          }}
        >
          <iframe
            src={fileUrl}
            title="File Preview"
            width="100%"
            height="100%"
            style={{ border: "none", borderRadius: "8px" }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
